import { HttpHandlerFn, HttpRequest } from '@angular/common/http';

export function apiKeyInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const newReq = req.clone({
    headers: req.headers.set('ApiKey', '0cee3994bc6e46f580296505c08324b6'),
  });
  return next(newReq);
}
